import { Button, InventoryType, ReportItem, SwellDirection, WindDirection } from '@vessel-reports/noon/state/noon.types';

export const buttons: Button[] = [
  {
    id: 1,
    active: false,
    title: 'AT PORT',
    value: 2
  },
  {
    id: 2,
    active: false,
    title: 'AT SEA',
    value: 1
  }
];

export const inventories: InventoryType[] = [
  {
    id: 1,
    title: 'HFO',
    value: 1
  },
  {
    id: 2,
    title: 'MGO',
    value: 2
  },
  {
    id: 3,
    title: 'Main Engine - Cylinder Oil',
    value: 3
  },
  {
    id: 4,
    title: 'Main Engine - System Oil',
    value: 4
  },
  {
    id: 5,
    title: 'Generator Engine - System Oil',
    value: 5
  },
  {
    id: 6,
    title: 'Fresh Water',
    value: 37
  }
];

export const SeaSteps = [
  { id: 1, step: 1, active: false, title: 'Port Info' },
  { id: 2, step: 2, active: false, title: 'Vessel Stats' },
  { id: 3, step: 3, active: false, title: 'Consumption' },
  { id: 4, step: 4, active: false, title: 'Weather' }
];

export const PortSteps = [
  { id: 1, step: 1, active: false, title: 'Port Info' },
  { id: 2, step: 2, active: false, title: 'Consumption' }
];

export const VesselTypes: Button[] = [
  { id: 1, title: 'BALLAST', active: false, value: 0 },
  { id: 2, title: 'LADEN', active: false, value: 1 }
];

export const WindDirections: WindDirection[] = [
  { direction: 'N' },
  { direction: 'S' },
  { direction: 'E' },
  { direction: 'W' },
  { direction: 'NE' },
  { direction: 'NW' },
  { direction: 'SE' },
  { direction: 'SW' }
];

export const SwellDirections: SwellDirection[] = [
  { direction: 'N' },
  { direction: 'S' },
  { direction: 'E' },
  { direction: 'W' },
  { direction: 'NE' },
  { direction: 'NW' },
  { direction: 'SE' },
  { direction: 'SW' }
];

export const PortInformationSea: ReportItem[] = [
  {
    id: null,
    report_item_id: 2,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 4,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 5,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 1,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 3,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 6,
    description: null,
    value: null,
    remarks: null
  }
];

export const PortInformationPort: ReportItem[] = [
  {
    id: null,
    report_item_id: 1,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 6,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 38,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 39,
    description: null,
    value: null,
    remarks: null
  }
];
export const VesselStatus: ReportItem[] = [
  {
    id: null,
    report_item_id: 7,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 8,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 9,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 14,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 10,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 11,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 12,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 13,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 16,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 17,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 15,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 18,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 19,
    description: null,
    value: null,
    remarks: null
  }
];

export const Consumptions: ReportItem[] = [
  {
    id: null,
    report_item_id: 20,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 21,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 22,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 23,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 24,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 25,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 26,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 27,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 28,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 29,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 30,
    description: null,
    value: null,
    remarks: null
  }
];

export const Weather: ReportItem[] = [
  {
    id: null,
    report_item_id: 31,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 32,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 33,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 34,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 35,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 37,
    description: null,
    value: null,
    remarks: null
  },
  {
    id: null,
    report_item_id: 36,
    description: null,
    value: null,
    remarks: null
  }
];

export enum REPORT_TYPE {
  SEA = 1,
  PORT
}

export enum REPORT_STATUS {
  DRAFT = 1,
  SAVED,
  SUBMITTED
}
